import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FinanceMrfListing from './financeMrfLisitng';
import { fetchMrfList, dropDownForMrfType } from 'services/redux/MaterialRequistionForm/action';

const mapStateToProps = (state) => ({
  mrfListingFinance: state.MaterialRequistionForm.mrfListingFinance,
  mrfTypeDropdown: state.MaterialRequistionForm.mrfTypeDropdown
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchMrfList,
      dropDownForMrfType
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(FinanceMrfListing);
